import { computed, reactive } from '@vue/composition-api';
import { WORK_TYPE_NAME_DEFAULT } from '@/lib/johaisetsu/settouSagyouReport/johaisetsuReportUtil';
import { filterJohaisetsuTypesByGroup } from '@/lib/johaisetsu/johaisetsuHelper';
import { useJohaisetsuSagyouContext } from '@/components/Sp/Johaisetsu/composables/useJohaisetsuSagyouContext';
import { UseSettouPatrolContextParams, UseSettouPatrolContextResult } from '@/components/Sp/Johaisetsu/types';

interface State {
  selectedJohaisetsuType: string | null;
}

export default function useSettouPatrolContext(params: UseSettouPatrolContextParams): UseSettouPatrolContextResult {
  const state = reactive<State>({
    selectedJohaisetsuType: params.selectedJohaisetsuType,
  });
  const settouPatrolContext = useJohaisetsuSagyouContext();
  const johaisetsuTypeGroup = settouPatrolContext.johaisetsuTypeGroup;
  const johaisetsuTypeGroupName = settouPatrolContext.johaisetsuTypeGroupName;
  const johaisetsuTypeMap = window.johaisetsuMaster.johaisetsuTypeMap;
  const johaisetsuTypeObj = johaisetsuTypeMap[state.selectedJohaisetsuType || ''];
  const workType = johaisetsuTypeObj.work_type ?? '';
  const johaisetsuTypes = filterJohaisetsuTypesByGroup(settouPatrolContext.johaisetsuTypeGroup);
  const roadNames = JSON.parse(JSON.stringify(window.master.roadNameDirections.filter(e => !e.isDummy)));
  const isShowJohaisetsuTypeSelect = johaisetsuTypes.length > 1;
  const johaisetsuTypeNameDisp = computed<string>(() => {
    let ret = '';
    if (isShowJohaisetsuTypeSelect) {
      ret = `(${workType})`;
    }
    return ret;
  });
  const sagyouActionLabel = settouPatrolContext.sagyouActionLabel ?? WORK_TYPE_NAME_DEFAULT;
  const workStartLabel = `${sagyouActionLabel}開始`;
  const restartWorkingLabel = `${sagyouActionLabel}再開`;
  const pauseWorkingLabel = `${sagyouActionLabel}一時停止`;
  const stopWorkingLabel = `${sagyouActionLabel}終了`;

  return {
    state,
    johaisetsuTypeGroup,
    johaisetsuTypeGroupName,
    johaisetsuTypeNameDisp,
    workType,
    johaisetsuTypeMap,
    johaisetsuTypes,
    roadNames,
    isShowJohaisetsuTypeSelect,
    sagyouActionLabel,
    workStartLabel,
    restartWorkingLabel,
    pauseWorkingLabel,
    stopWorkingLabel,
  };
}
